<template lang="html">
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <h2 class="headline">
            <span class="font-weight-bold d-flex align-center">
              <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
              History Detail
            </span>
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <v-list-item>
            <v-list-item-avatar size="72" class="order_history_avatar primary">
              <template v-if="transaction.remark === 'RESERVATION'">
                <v-img src="@/assets/images/svg/order_reservation.svg" contain />
              </template>
              <template v-else-if="transaction.remark === 'OL-TAKE-AWAY'">
                <v-img src="@/assets/images/svg/order_takeaway.svg" contain />
              </template>
              <template v-else-if="transaction.remark === 'DELIVERY'">
                <v-img src="@/assets/images/svg/order_delivery.svg" contain />
              </template>
              <template v-else-if="transaction.remark === 'OL-DINE-IN'">
                <v-img src="@/assets/images/svg/order_dinein.svg" contain />
              </template>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                <span>
                  {{ transaction.remark }}
                </span>
                <span class="ml-1 __self-tag primary--text">
                  {{ transaction.order_no }}
                </span>
              </v-list-item-title>
              <v-list-item-subtitle class="items font-12 mt-1 mb-2 __white-space-normal">
                <div>
                  <span class="grey--text">{{ transaction.forder_date }}</span>
                </div>
                <div class="font-12">
                  <span v-mask-money="transaction.total_amount" class="font-weight-bold" />
                  <span class="grey--text font-weight-bold mx-1">.</span>
                  <span :class="[`font-weight-bold`, { 'status--text': transaction.status !== 'X', 'red--text': transaction.status === 'X' }]">
                    {{ transaction.status_desc }}
                  </span>
                </div>
                <div v-if="transaction.notes !== ''" class="font-weight-bold __white-space-normal">
                  {{ transaction.notes }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="ma-auto" style="width: 100%;" />
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <template v-if="transaction.remark === 'DELIVERY'">
            <div class="d-flex">
              <div class="d-flex title-wrapper">
                <div class="__title-list">
                  Delivery option:
                  <span v-if="transaction.shipping_delivery_type === '1'" class="ml-1">
                    Restaurant Delivery
                  </span>
                  <span v-else-if="transaction.shipping_delivery_type === '2' && transaction.shipping_courier_id === 'S08'" class="ml-1">
                    Gosend
                  </span>
                  <span v-else-if="transaction.shipping_delivery_type === '2' && transaction.shipping_courier_id === 'S09'" class="ml-1">
                    Grab Express
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="p-relative d-flex flex-column shipping-wrapper">
                <div class="__d-from align-center">
                  <div class="__d-from-pin mr-2">
                    <img src="@/assets/images/svg/marker.svg">
                  </div>
                  <span class="font-weight-bold">
                    {{ transaction.store_name }}
                  </span>
                </div>
                <div class="d-flex __d-shipping">
                  <div class="">
                    <div class="__d-from-pin mr-2">
                      <img src="@/assets/images/svg/destination.svg">
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="__d-shipping-radius">
                      Delivery Location . {{ transaction.shipping_radius }} km
                    </div>
                    <div class="__d-shipping-address font-weight-bold">
                      {{ transaction.shipping_address }}
                    </div>
                  </div>
                </div>
                <div class="__d-shipping-distance" />
              </div>
            </div>
          </template>
          <template v-else-if="transaction.remark === 'OL-TAKE-AWAY'">
            <div class="d-flex align-center justify-center">
              <div class="d-flex title-wrapper flex-column justify-center">
                <div class="d-flex __title-list justify-center mb-2">
                  Take Away Time
                </div>
                <div class="d-flex justify-center">
                  <span class="order-tag ml-1">
                    {{ transaction.ftake_time }}
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="transaction.remark === 'OL-DINE-IN'">
            <div class="d-flex align-center justify-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="svg-table-cart">
                  <g id="surface1" transform="translate(-0.992 -3.473)">
                    <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ $t('table') }} {{ transaction.table_no }}
              </div>
            </div>
          </template>
          <template v-else-if="transaction.remark === 'RESERVATION'">
            <div class="d-flex align-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svg-calender-cart">
                  <g id="Group_25940" data-name="Group 25940" transform="translate(-32 -501)">
                    <rect id="Rectangle_43012" data-name="Rectangle 4304" width="24" height="24" transform="translate(32 501)" fill="#fff" opacity="0" />
                    <path id="calendar_today_FILL0_wght400_GRAD0_opsz48" d="M7.282,21.088A1.314,1.314,0,0,1,6,19.806V6.563A1.314,1.314,0,0,1,7.282,5.282H8.67V4h1.388V5.282h7.262V4h1.388V5.282H20.1a1.314,1.314,0,0,1,1.282,1.282V19.806A1.314,1.314,0,0,1,20.1,21.088Zm0-1.282H20.1V10.622H7.282Zm0-10.466H20.1V6.563H7.282Zm0,0v0Z" transform="translate(30.31 500.456)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ formatReserveDate }}, {{ transaction.freserve_time }}
              </div>
            </div>
            <div class="d-flex align-center">
              <div class="d-flex mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="ml-1 svg-table-cart">
                  <g id="surface1" transform="translate(-0.992 -3.473)">
                    <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                  </g>
                </svg>
              </div>
              <div class="font-14 font-weight-bold primary--text">
                {{ transaction.total_guest }} {{ $t('table') }}
              </div>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="ma-auto" style="width: 100%;" />
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="d-flex">
            <div class="d-flex title-wrapper">
              <div class="__title-list">
                Order Detail
              </div>
            </div>
          </div>
          <div class="__price-wrapper d-flex flex-column mt-3">
            <div class="__data-price">
              <h4>
                Price
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round((transaction.order_amount) * 100) / 100 }}
              </h4>
            </div>
            <div v-if="transaction.discount_amount > 0" class="__data-price">
              <h4>
                Discount
                <span v-if="transaction.discount_voucher_code && transaction.discount_voucher_code !== ''">
                  ({{ transaction.discount_voucher_code }})
                </span>
              </h4>
              <v-spacer />
              <h4 class="color-price">
                - {{ Math.round((transaction.discount_amount) * 100) / 100 }}
              </h4>
            </div>
            <template v-if="transaction.remark === 'DELIVERY' || transaction.remark === 'OL-TAKE-AWAY'">
              <div v-if="transaction.trans_fee_rate !== '0.00'" class="__data-price">
                <h4>
                  Convenience Fee ({{ transaction.trans_fee_rate * 100 }}%)
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round(transaction.trans_fee_amount) }}
                </h4>
              </div>
              <div v-if="transaction.payment_charge !== '0.00'" class="__data-price">
                <h4>
                  Payment Charge
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round((transaction.payment_charge) * 100) / 100 }}
                </h4>
              </div>
              <template v-if="selected_outlet.pos_take_away_with_service_charge">
                <div v-if="transaction.service_charge_amount !== '0.00'" class="__data-price">
                  <h4>
                    Service Charge
                  </h4>
                  <v-spacer />
                  <h4>
                    {{ Math.round((transaction.service_charge_amount) * 100) / 100 }}
                  </h4>
                </div>
              </template>
            </template>
            <template v-else>
              <div v-if="transaction.remark === 'RESERVATION'" class="__data-price">
                <h4>
                  Convenience Fee
                </h4>
                <v-spacer />
                <h4>
                  {{ Number(transaction.trans_fee_amount) }}
                </h4>
              </div>
              <div v-if="transaction.service_charge_amount !== '0.00'" class="__data-price">
                <h4>
                  Service Charge
                </h4>
                <v-spacer />
                <h4>
                  {{ Math.round((transaction.service_charge_amount) * 100) / 100 }}
                </h4>
              </div>
            </template>
            <div v-if="Number(transaction.tax_amount) !== 0" class="__data-price">
              <h4>
                {{ selected_outlet.tax_name }}
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round((transaction.tax_amount) * 100) / 100 }}
              </h4>
            </div>
            <div v-if="transaction.remark === 'DELIVERY'" class="__data-price">
              <h4>
                Delivery Fee
              </h4>
              <v-spacer />
              <template v-if="transaction.shipping_cost === '0.00'">
                <h4>
                  FREE
                </h4>
              </template>
              <h4 v-else v-mask-money="transaction.shipping_cost" />
            </div>
            <div v-if="transaction.redeemed_amount > 0" class="__data-price">
              <h4>
                Ditebus {{ Math.round(transaction.redeemed_points) }} pts
              </h4>
              <v-spacer />
              <h4>
                - {{ Math.round(transaction.redeemed_amount) }}
              </h4>
            </div>
            <div v-if="transaction.rounded_amount && Number(transaction.rounded_amount) !== 0" class="__data-price">
              <h4>
                Pembulatan
              </h4>
              <v-spacer />
              <h4>
                {{ Math.round(transaction.rounded_amount) }}
              </h4>
            </div>
            <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
            <div class="__data-price font-weight-bold">
              <h4>
                Total
              </h4>
              <v-spacer />
              <h4 v-mask-money="transaction.total_amount" />
            </div>
            <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
            <div class="__data-price">
              <span v-if="transaction.is_paid === 1" class="order-is-paid">
                Sudah bayar
              </span>
              <span v-else-if="transaction.is_paid === 0" class="order-is-unpaid">
                Belum bayar
              </span>
            </div>
            <template v-if="$isEmpty(transaction.payment_log) && transaction.is_paid === 0">
              <v-divider class="ma-auto divider-dashed" style="width: 100%;" />
              <div class="__data-price">
                <h4>
                  Bayar saat terima pesanan
                </h4>
                <v-spacer />
                <h4 v-mask-money="transaction.total_amount" class="font-weight-bold" />
              </div>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider class="ma-auto" style="width: 100%;" />
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="d-flex">
            <div class="d-flex title-wrapper">
              <div class="__title-list">
                Item Detail
              </div>
            </div>
          </div>
          <v-list two-line class="list-product">
            <template v-for="(item, idx) in transaction.items">
              <v-list-item :key="idx + '-product'">
                <v-list-item-avatar class="list-img-square">
                  <img :src="item.product_combo_id === 0 ? item.product_photo_xs : item.product_combo_photo_xs" @error="imageLoadError">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.qty }}x - {{ item.item_name }} <span v-if="item.item_variant_name">({{ item.item_variant_name }})</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.item_product_combo != ''">
                    <template v-for="(child, key) in item.item_product_combo">
                      <span v-if="child.item_variant_name !== ''" :key="key">
                        {{ child.item_name }} ({{ child.item_variant_name }})
                      </span>
                      <span v-else :key="key">
                        {{ child.item_name }}
                      </span>
                      <span v-if="(item.item_product_combo.length - key) != 1" :key="key + '-plus'" v-html="'+'" />
                    </template>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.addon.length !== 0">
                    <template v-for="(addons_item, index) in item.addon">
                      {{ addons_item.name }}
                      <span v-if="(item.addon.length - index) !== 1" :key="index + '-plus'" v-html="'+'" />
                    </template>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.note !== ''">
                    <v-icon left color="grey lighten-1">
                      mdi-file-document-outline
                    </v-icon>
                    <span>
                      {{ item.note }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  <v-list-item-subtitle class="font-weight-bold">
                    <span v-mask-money-only="item.amount" />
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  getDataDetail as getDataDetailOutlet
} from '@/api/outlet'
import {
  getDataDetail as getDataDetailOrder
} from '@/api/order'
export default {
  data() {
    return {
      transaction: {},
      selected_outlet: {}
    }
  },
  computed: {
    formatReserveDate() {
      const d = new Date(this.transaction.reserve_date)
      var day = d.getDay()
      const date = d.getDate()
      var month = d.getMonth()
      const year = d.getFullYear()

      switch (day) {
        case 0: day = this.$t('date.sunday'); break
        case 1: day = this.$t('date.monday'); break
        case 2: day = this.$t('date.tuesday'); break
        case 3: day = this.$t('date.wednesday'); break
        case 4: day = this.$t('date.thursday'); break
        case 5: day = this.$t('date.friday'); break
        case 6: day = this.$t('date.saturday'); break
      }

      switch (month) {
        case 0: month = this.$t('date.january'); break
        case 1: month = this.$t('date.february'); break
        case 2: month = this.$t('date.march'); break
        case 3: month = this.$t('date.april'); break
        case 4: month = this.$t('date.may'); break
        case 5: month = this.$t('date.june'); break
        case 6: month = this.$t('date.july'); break
        case 7: month = this.$t('date.august'); break
        case 8: month = this.$t('date.september'); break
        case 9: month = this.$t('date.october'); break
        case 10: month = this.$t('date.november'); break
        case 11: month = this.$t('date.december'); break
      }

      return day + ', ' + date + ' ' + month + ' ' + year
    }
  },
  mounted() {
    this.fetchTransactions()
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    },
    goBack() {
      this.$router.push({ name: 'transactions' }).catch(() => {})
    },
    async loadOutlet(id) {
      try {
        const { data } = await getDataDetailOutlet(id)
        this.$store.state.loading_axios = false
        this.selected_outlet = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async fetchTransactions() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.$store.state.loading_axios = false
        this.transaction = data.data
        this.loadOutlet(this.transaction.store_id)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
